// packages
import { json } from 'd3-fetch';
import yall from 'yall-js';

// local
import { getGeographyUrl } from './constants';

// components
import Results from './components/Results.svelte';
import ResultsWithMap from './components/ResultsWithMap.svelte';
import StackedResults from './components/StackedResults.svelte';
import BalanceOfPowerSummary from './components/BalanceOfPowerSummary.svelte';

// stores
import {
  createStateFeed,
  createOfficeFeed,
  createRaceLookup,
  createRaceStore,
} from './stores/state';

// utils
import { AdLoader } from './ads/loader';
import activateDropdown from './utils/dropdown';
import loadJsonScript from './utils/load-json-script';
import topojsonToGeojson from './utils/topojson-to-geojson';

// types
import type { Readable } from 'svelte/store';
import type { RaceInterface, StateContextInterface } from './interfaces';

const context = loadJsonScript<StateContextInterface>('state-context');
const geographyUrl = getGeographyUrl(context.postal);

async function main() {
  activateDropdown(document.querySelector('.dropdown-counties') as Element);
  activateDropdown(document.querySelector('.dropdown-states') as Element);

  const racesOnPage = document.querySelectorAll('.race-result');

  const feed = await createStateFeed(context.postal);
  const store = createRaceLookup(feed);

  let presidentRace: Readable<RaceInterface>;

  for (let idx = 0; idx < racesOnPage.length; idx++) {
    const target = racesOnPage[idx];
    const id = target.id;
    const race = createRaceStore(store, id);

    if (idx === 0) {
      presidentRace = race;
    } else {
      new Results({
        target,
        props: { race },
      });
    }
  }

  const topology = await json(geographyUrl);
  const [geography, roads, cities] = topojsonToGeojson(topology, [
    context.geography,
    'roads',
    'cities',
  ]);

  new ResultsWithMap({
    target: document.getElementById('temp'),
    props: {
      race: presidentRace,
      geography,
      roads,
      cities,
    },
  });

  // only do State Senate and State Assembly on CA page
  if (context.postal === 'ca') {
    const stateSenateFeed = createOfficeFeed(feed, 'Z');

    new BalanceOfPowerSummary({
      target: document.getElementById('state-senate-summary') as HTMLElement,
      props: {
        races: stateSenateFeed,
      },
    });

    new StackedResults({
      target: document.getElementById('state-senate-races') as HTMLElement,
      props: {
        races: stateSenateFeed,
      },
    });

    const stateAssemblyFeed = createOfficeFeed(feed, 'Y');

    new BalanceOfPowerSummary({
      target: document.getElementById('state-assembly-summary') as HTMLElement,
      props: {
        races: stateAssemblyFeed,
      },
    });

    new StackedResults({
      target: document.getElementById('state-assembly-races') as HTMLElement,
      props: {
        races: stateAssemblyFeed,
      },
    });
  }

  // Kickstart the ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
}

main().catch(console.error);
document.addEventListener('DOMContentLoaded', yall);
